// PREVIEW, READ-ONLY (Karan 23/10/2026). On a Firebase preview channel
// (asp-track--<channel>-<hash>.web.app) Track runs against the LIVE data with
// every write refused: Firestore writes, server functions, Storage uploads and
// Google (Gmail / Drive / Calendar) changes. A banner says so on every screen.
// localStorage 'track-readonly' = '1' turns it on anywhere, for testing.
export const READ_ONLY = (() => {
  try {
    // ASP's own preview channels only (asp-track--<channel>.web.app); the Track Test demos write freely.
    if (/^asp-track--[a-z0-9-]+\.web\.app$/i.test(location.hostname)) return true;
    return localStorage.getItem('track-readonly') === '1';
  } catch (_) { return false; }
})();

export class ReadOnlyPreview extends Error {
  constructor(what = 'This') { super(`${what} is switched off in the preview — it’s read-only.`); this.name = 'ReadOnlyPreview'; this.code = 'read-only-preview'; }
}
export function refuse(what) { throw new ReadOnlyPreview(what); }

// Google's own APIs are called with fetch. In the preview, anything that isn't
// a read to Gmail, Drive, Calendar or Sheets is refused here — one net for them all.
if (READ_ONLY && typeof window !== 'undefined' && window.fetch && !window.__trackRoFetch) {
  window.__trackRoFetch = true;
  const real = window.fetch.bind(window);
  const GOOGLE = /^https:\/\/(gmail\.googleapis\.com|www\.googleapis\.com\/(drive|upload|calendar|gmail)|sheets\.googleapis\.com|people\.googleapis\.com)/i;
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (GOOGLE.test(url) && !['GET', 'HEAD'].includes(method)) return Promise.reject(new ReadOnlyPreview('Changing Google mail, files or calendars'));
    return real(input, init);
  };
}
